<script setup lang="ts">
import { getDownloadCount } from "@/api/download/getDownloadCount";
import { postDownloadApp } from "@/api/download/postDownloadApp";
import { APP_TYPE, PLATFORM_TYPE } from "@/api/type";
import { IOptionItem } from "@/models";
import { localize } from "@/utils";
import { langStore, useLangSync } from "@/utils/langStore";
import HomeFooter from "@/views/home/HomeFooter.vue";
import HomeHeader from "@/views/home/HomeHeader.vue";
import { nextTick, onBeforeUnmount, onMounted, reactive, Ref, ref, computed } from "vue";
import { useRoute } from "vue-router";

const fullMouth_videoRef = ref<HTMLVideoElement | null>(null);
let observer: IntersectionObserver | null = null;

const sectionRefItems = Array(8)
  .fill(null)
  .map(() => ref<HTMLElement | null>(null));
const sectionItems: IOptionItem[] = [
  { label: "R2 Implant Solution", value: 0 },
  { label: "R2 Full mouth solution", value: 1 },
  { label: "Meg Aligner", value: 2 },
  { label: "R2 CAD/CAM", value: 3 },
  { label: "FaceGIDE", value: 4 }, 
  { label: "Facial Reconstruction", value: 5 },
  // 6번과 7번은 메뉴에 노출 시키지 않는다.
];

const state = reactive({
  active: 0,
  r2GateWindow: false,
  r2GateLite: false,
  smileCreator: false,
});

const route = useRoute();

requestAnimationFrame(() => {
  if (route.query.section) {
    changeSection(Number(route.query.section));
  }
});

const isProgrammaticScroll = ref(false);

function changeSection(value: number) {
  state.active = value;
  isProgrammaticScroll.value = true;

  const targetEl = sectionRefItems[value].value;
  if (!targetEl) return;

  targetEl.scrollIntoView({ behavior: "smooth" });

  // IntersectionObserver는 브라우저 구현에 따라 안정적이지 않을 수 있음.
  // 그래서 fallback으로 timeout 사용
  setTimeout(() => {
    isProgrammaticScroll.value = false;
  }, 800); // 스크롤 애니메이션 예상 시간
}

function onScroll() {
    if (isProgrammaticScroll.value) return; // 플래그가 있으면 무시
    const offsetY = window.scrollY;
    const margin = 120;
    let found = 0;
    sectionRefItems.forEach((refItem, idx) => {
      const el = refItem.value;
      if (el) {
        const top = el.getBoundingClientRect().top + window.scrollY - margin;
        if (offsetY >= top) found = idx;
      }
    });
    state.active = found;
}

// onMounted(() => {
//   observer = new IntersectionObserver(
//     (entries) => {
//       entries.forEach((entry) => {
//         if (entry.isIntersecting) {
//           const video = entry.target as HTMLVideoElement
//           if(entry.isIntersecting) {
//             video.play().catch((err => {
//               console.error("자동 재생 실패 :", err);
//             }));
//           } else {
//             video.pause();
//           }
//         }
//       })
//     },
//     {
//       threshold: 0.1, // 50% 이상 보이면 재생
//     }
//   )
//   observer.observe(fullMouth_videoRef.value!);
//   window.addEventListener("scroll", onScroll, { passive: true });
//   nextTick(onScroll);
// });

onBeforeUnmount(() => {
  window.removeEventListener("scroll", onScroll);
});

// // 10개의 동영상 상태 관리
// const isVideoPlaying = ref(Array(10).fill(false)); // 10개의 비디오 재생 상태를 관리하는 배열
// const showImage = ref(Array(10).fill(true)); // 10개의 이미지 표시 상태를 관리하는 배열

// function playVideo(index: number, event: MouseEvent) {
//   const currentVideo = (event.currentTarget as HTMLElement).querySelector('video'); // 클릭된 요소의 하위 비디오 요소를 참조
//   showImage.value[index] = false; // 해당 인덱스의 이미지 숨기기
//   console.log(currentVideo);

//   if (isVideoPlaying.value[index]) {
//     if (currentVideo) {
//       currentVideo.pause(); // 해당 비디오 일시 정지
//     }
//     isVideoPlaying.value[index] = false; // 재생 상태 업데이트
//   } else {
//     if (currentVideo) {
//       // 동영상이 종료되면 실행되는 이벤트 리스너 추가
//       currentVideo.addEventListener('ended', () => {
//         showImage.value[index] = true; // 동영상이 끝나면 이미지 다시 보이기
//         isVideoPlaying.value[index] = false; // 비디오 상태를 false로 업데이트
//         currentVideo.currentTime = 0; // 동영상을 처음으로 돌리기
//       });
//       currentVideo.play(); // 해당 비디오 재생
//     }
//     isVideoPlaying.value[index] = true; // 재생 상태 업데이트
//   }
// }

//HERE
const r2i3DownloadLink: Ref<string> = ref("https://download.r2playground.com");
const r2CadDownloadLink: Ref<string> = ref("https://r2gate.com/r2cad");


const isLoading = ref(false)

// 특정 타입 카운트 갱신 함수
const updateDownloadCount = async (type: APP_TYPE) => {
  try {
    if (!type) return
    const res = await getDownloadCount({
      type: type
    })
    const el = document.querySelector(`.count-num[data-type="${type}"]`) as HTMLElement
    if (el) {
      el.textContent = `Total : ${res.data.count.toLocaleString()}`
    }
  } catch (err) {
    console.error(`다운로드 카운트 API 호출 실패 (${type}):`, err)
  }
}

// 모든 타입 카운트 초기 로딩
const loadAllDownloadCounts = async () => {
  const elements = document.querySelectorAll('.count-num') as NodeListOf<HTMLElement>

  for (const el of Array.from(elements)) {
    const type = el.dataset.type
    if (!type) continue 
    if (type) {
      await updateDownloadCount(type as APP_TYPE)
    }
  }
}

// 페이지 로드 시 실행
onMounted(() => {
  window.addEventListener("scroll", onScroll, { passive: true });
  nextTick(onScroll);
  loadAllDownloadCounts()
});

  const onClickAppDownload = async (app: APP_TYPE, platform: PLATFORM_TYPE) => {
    const res = await postDownloadApp({
      downloadType: app,
      platformType: platform,
      usedLocationType: "VISITOR_WEB_APP",
    });
    if (res.isSuccess) {
      const link = document.createElement('a')
      link.href = res.data.url
      link.setAttribute('download', '')
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      updateDownloadCount(app)
    } else {
      alert('다운로드 링크를 가져오지 못했습니다.')
    }
  }

const r2gateSAyoutubeUrl = computed(() => {
  return langStore.value === 'en-US'
    ? 'https://www.youtube.com/playlist?list=PLWv4l-DIWsiHYpJrNW-afWa6ulvCHnOdC'
    : 'https://www.youtube.com/playlist?list=PLWv4l-DIWsiHcLYAB8Jcmk-fpie4SxXdd'
});

useLangSync();
</script>

<template>
  <div id="wrap">
    <div class="scrollspy-body" data-spy="scroll" data-target=".navbar">
      <!-- header -->
      <home-header />
      <!-- //header -->

      <!-- container -->
      <main id="ct" class="solution">
        <!-- 페이지 시작 -->
        <div class="intro">
          <div class="container">
            <span>{{ localize("임상을 쉽고, 즐겁게 만드는") }}</span>
            <h1 class="fs-1 font-poppins">R2 Solutions</h1>
            <p
              class="fs-4"
              v-html="localize('R2 solution은 오랫 동안 임상에서 축적되어 온 다양한 지식과<br /> 이론들을 디지털 방식으로 구현하여, 누구나 쉽게 활용할 수 있도록 개발된 진단 소프트웨어 입니다.')"/>
          </div>
        </div>
        <nav class="navbar"> 
          <ul class="nav nav-pills">
            <li v-for="item in sectionItems" class="nav-item">
              <a
                class="nav-link"
                :class="{ active: state.active === item.value }"
                @click="changeSection(item.value as number)"
              >
                {{ item.label }}
              </a>
            </li>
          </ul>
        </nav>
        <div :ref="sectionRefItems[0]" id="solution1">
          <div class="container">
            <div class="solution-title-wrap">
              <h2>R2 Implant Solution</h2>
              <p
                v-html="localize('<strong>임플란트 치료 계획 수립부터 수술 가이드 디자인, 네비게이션 수술까지</strong><br/>성공적인 임플란트 치료를 위한 강력한 디지털 솔루션을 제공합니다.')"
              />
            </div>
            <a class="main-thumb video">
              <video controls poster="@/assets/home/img/solution/r2solution1.jpg">
                <source src="https://playgroundmaintenance.blob.core.windows.net/webstaticassets/Video/R2_Impalant_solution/20190218_R2GUIDE_AD_EN.mp4" type="video/mp4"/>
                Your browser does not support the video tag.
              </video>
            </a>
            <div class="program-items">
              <div class="item" id="solution-r2gate-sa">
                <div class="item-top">
                  <a class="item-thumb video">
                    <video controls>
                      <source src="https://playgroundmaintenance.blob.core.windows.net/webstaticassets/Video/R2GATE_SA/R2GATE_SA_Teasure.mp4" type="video/mp4"/>
                      Your browser does not support the video tag.
                    </video>
                  </a>                  
                  <!-- <div class="item-thumb">
                    <img src="@/assets/home/img/solution/r2solution1-1.jpg" alt="" />
                  </div> -->
                  <div class="item-desc">
                    <h3>R2GATE SA </h3>
                    <p
                      v-html="
                        localize('<strong>R2GATE S.A는 가장 직관적인 임플란트 진단 소프트웨어입니다.</strong>')
                      "
                    />
                    <ul>
                      <li>
                        {{
                          localize("Single Implant부터 Full Mouth Case까지 다양한 임상 케이스에 효과적인 수술 계획 수립")
                        }}
                      </li>
                      <li>
                        {{
                          localize("Digital EYE를 활용한 시술 부위의 골질 분석")
                        }}
                      </li>
                      <li>
                        {{
                          localize("초기 고정 확보를 위한 맞춤형 Drilling Sequence 제공")
                        }}
                      </li>
                      <li>
                        {{
                          localize("R2 Surgical Guide 및  Stackable Guide 디자인 지원")
                        }}
                      </li>
                      <li>
                        {{
                          localize("R2 Real Navi System 전용 파일 추출 가능")
                        }}
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="item-btns" :class="{ active: state.r2GateWindow }">
                  <button
                    type="button"
                    class="btn-drop-down"
                    @click="state.r2GateWindow = !state.r2GateWindow"
                  ></button>
                  <div>
                    <div class="count-wrap">
                      <p>Program Download</p>
                      <p class="count-num"  data-type="R2GATE_SA">Total : 0</p>
                    </div>
                      <div class="btns-wrap">
                        <button @click="onClickAppDownload('R2GATE_SA', 'windows')" :disabled="isLoading" class="btn btn-maincolor" target="_blank" rel="noopener noreferrer">
                          Windows
                          <i class="icon icon-download-wh"></i>
                        </button>
                      </div>
                  </div>
                  <div>
                    <p>Manual (implant planning)</p>
                    <a href="https://playgroundmaintenance.blob.core.windows.net/webstaticassets/MANUAL/R2GateSA_QuickManual_KR.pdf" class="btn btn-outline btn-manual" target="_blank" rel="noopener noreferrer"> <i class="icon-manual"></i>KOR </a>
                    <a href="https://playgroundmaintenance.blob.core.windows.net/webstaticassets/MANUAL/R2GateSA_QuickManual_EN.pdf" class="btn btn-outline btn-manual" target="_blank" rel="noopener noreferrer"> <i class="icon-manual"></i>ENG </a>
                    <a :href="r2gateSAyoutubeUrl" class="btn btn-outline btn-manual" target="_blank" rel="noopener noreferrer"> 
                      <img class="custom-icon-youtube" src="@/assets/playground/img/youtube.png" alt="" /> YouTube
                    </a>
                  </div>
                  <div>
                    <p>Demo project download</p>
                    <a href="https://playgroundmaintenance.blob.core.windows.net/webstaticassets/MANUAL/R2GateSA_Demo_Case.zip" class="btn btn-outline"> Demo<i class="icon icon-download"></i> </a>
                  </div>
                </div>
                <div class="precautions">
                  <p>PRECAUTIONS</p>
                  <div class="tb-head">Prerequisite</div>
                  <table>
                    <tbody>
                      <tr>
                        <td>Processor</td>
                        <td>Intel Core i7</td>
                      </tr>
                      <tr>
                        <td rowspan="2">GPU</td>
                        <td>NVIDIA GeForce GTX660 D5 2G Higher</td>
                      </tr>
                      <tr>
                        <td>Radeon HD7850 D5 2GG Higher</td>
                      </tr>
                      <tr>
                        <td>Disk space requirements</td>
                        <td>1TB Higher</td>
                      </tr>
                      <tr>
                        <td>Operating system</td>
                        <td>Microsoft Windows 7, 10</td>
                      </tr>
                      <tr>
                        <td rowspan="3">Other requirements</td>
                        <td>Higher-resolution (1680X1050 higher) monitor</td>
                      </tr>
                      <tr>
                        <td>keyboard (wheeling enable) and mouse</td>
                      </tr>
                      <tr>
                        <td>Internet access</td>
                      </tr>
                      <tr>
                        <td class="bx" colspan="2">
                          <p class="break-all">
                            <b>SHA 256</b> 9334d1653ae6b135825cfc1985e8dfe9c30120916eed027f0dc3b921547b4484
                          </p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="item" id="solution-r2gate-lite-sa">
                <div class="item-top">
                  <a class="item-thumb video">
                    <video controls>
                      <source src="https://playgroundmaintenance.blob.core.windows.net/webstaticassets/Video/R2GATE_SA/R2GATE_SA_Lite_Teasure.mp4" type="video/mp4"/>
                      Your browser does not support the video tag.
                    </video>
                  </a>
                  <div class="item-desc">
                    <h3>R2GATE Lite SA</h3>
                    <div
                      v-html="
                        localize('<strong>R2GATE Lite는 임플란트 진단 컨펌을 위한 전용 애플리케이션입니다.</strong><br/>R2GATE 설치 없이도 PC, Mac, iOS, Android 등 다양한 기기에서 간편하게 실행할 수 있으며,<br/>R2 Planner 또는 R2 Center에서 생성된 임플란트 진단 파일을 자동으로 다운로드하여<br/>수술 계획을 확인하거나 직접 수정할 수 있습니다.')
                      "
                    />
                  </div>
                </div>
                <div class="item-btns" :class="{ active: state.r2GateLite }">
                  <button type="button" class="btn-drop-down" @click="state.r2GateLite = !state.r2GateLite"></button>
                  <div>
                    <div class="count-wrap">
                      <p>Program Download</p>
                      <p class="count-num" data-type="R2GATE_LITE_SA">Total : 0</p>
                    </div>
                    <div class="btns-wrap">
                      <button @click="onClickAppDownload('R2GATE_LITE_SA', 'windows')" :disabled="isLoading" class="btn btn-maincolor" target="_blank" rel="noopener noreferrer">
                        Windows
                        <i class="icon icon-download-wh"></i>
                      </button>
                      <button @click="onClickAppDownload('R2GATE_LITE_SA', 'macosx')" :disabled="isLoading" class="btn btn-maincolor" target="_blank" rel="noopener noreferrer">
                        MacOSX
                        <i class="icon icon-download-wh"></i>
                      </button>
                      <button @click="onClickAppDownload('R2GATE_LITE_SA', 'ios')" :disabled="isLoading" class="btn btn-maincolor" target="_blank" rel="noopener noreferrer">
                        iOS
                        <i class="icon icon-download-wh"></i>
                      </button>
                      <button @click="onClickAppDownload('R2GATE_LITE_SA', 'android')" :disabled="isLoading" class="btn btn-maincolor" target="_blank" rel="noopener noreferrer">
                        Android
                        <i class="icon icon-download-wh"></i>
                      </button>
                    </div>
                  </div>
                  <div>
                    <p>Manual</p>
                    <div>
                      <a href="https://playgroundmaintenance.blob.core.windows.net/webstaticassets/MANUAL/R2GateLiteSA_QuickManual_KR.pdf" class="btn btn-outline btn-manual" target="_blank" rel="noopener noreferrer"> <i class="icon-manual"></i>KOR </a>
                      <a href="https://playgroundmaintenance.blob.core.windows.net/webstaticassets/MANUAL/R2GateLiteSA_QuickManual_EN.pdf" class="btn btn-outline btn-manual" target="_blank" rel="noopener noreferrer"> <i class="icon-manual"></i>ENG </a>
                      <a :href="r2gateSAyoutubeUrl" class="btn btn-outline btn-manual disabled" target="_blank" rel="noopener noreferrer"> 
                        <img class="custom-icon-youtube" src="@/assets/playground/img/youtube.png" alt="" /> YouTube
                      </a>
                    </div>
                  </div>
                </div>
                <div class="precautions">
                  <p>PRECAUTIONS</p>
                  <div class="tb-head">Prerequisite</div>
                  <table>
                    <tbody>
                      <tr>
                        <td v-html="localize('')" />
                        <td>
                          R2GATE Lite for PC(Windows) and Mac is free download.<br />
                          But license needed for activation, please ask it to your sales rep or R2-CENTER.
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div class="tb-head">Caution</div>
                  <table>
                    <tbody>
                      <tr>
                        <td>
                          R2GATE Lite for Mac might be blocked by Apple safety policy. so when you open it, if it
                          doesn't work, please press "Ctrl" key and click the right button of mouse, then choose "open".
                          when windows for use confirmation pop-up, choose "open" again.
                          <div class="bx">
                            <p class="break-all">
                              <b>SHA256(iOS)</b> 250117fe4cee5e6de4a6ceac853462ce883824789187c3a889bc89af87affcca
                            </p>
                            <p class="break-all">
                              <b>SHA256(Windows)</b> c63b6d37f675308b5bd0fd77badb2b4a3a6817bfc90abc8fc351d9bf371c307c
                            </p>
                            <p class="break-all">
                              <b>SHA256(MacOSX)</b> c98608c0a42c8556134a3a9e42de5f331a8a205fc1d339e90549e2ba2fdbfbe5
                            </p>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <a href="" class="btn btn-outline">Sample Data Download <i class="icon icon-download"></i></a>
                </div>
              </div>
              <div class="item">
                <div class="item-top">
                  <div class="item-thumb">
                    <img src="@/assets/home/img/solution/r2solution-r2guide.svg " alt="" />
                  </div>
                  <div class="item-desc">
                    <h3>R2 Guide</h3>
                    <div
                      v-html="
                        localize('<strong>R2GATE SA의 수술 계획을 현실로 구현하는 수술용 가이드</strong><br/>R2가이드는 R2GATE SA의 수술 계획을 기반으로, 메탈 슬리브 없이 3D 프린팅만으로 제작됩니다.<br/>자유로운 오프셋 설정을 통해 다양한 드릴 시스템과 호환되며,<br/>R2Aid를 활용해 심플 가이드부터 풀 가이드까지 유연한 디자인이 가능합니다.<br/>또한, 사용자의 선호에 따라 전용 메탈 슬리브가 포함된 디자인도 지원합니다.')
                      "
                    />
                  </div>
                </div>
              </div>
              <div class="item">
                <div class="item-top">
                  <a class="item-thumb video">
                    <video controls >
                      <source src="https://playgroundmaintenance.blob.core.windows.net/webstaticassets/Video/R2_Impalant_solution/R2_Real_Navi.mov" type="video/mp4"/>
                      Your browser does not support the video tag.
                    </video>
                  </a>
                  <div class="item-desc">
                    <h3>R2 Real Navi System</h3>
                    <div
                      v-html="
                        localize('<strong>가이드 없이 바로 수술 가능한 디지털 내비게이션</strong><br/>R2GATE SA에서 임플란트 계획을 수립한 후, 별도의 가이드 없이 즉시 수술이 가능합니다.<br/>R2 Real Navi는 첨단 스트레오 카메라와 트래킹 기술을 활용해 핸드피스와 환자의 움직임을 실시간으로 추적하고 반영함으로써,<br/>정확한 드릴링과 임플란트 식립을 정밀하게 안내합니다.<br/>또한 시술 중 계획 수정이 가능해, 뛰어난 자유도와 정밀도를 동시에 제공합니다.')
                      "
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div :ref="sectionRefItems[1]" id="solution2">
          <div class="container">
            <div class="solution-title-wrap">
              <h2>R2 Full mouth solution</h2>
              <span>{{ localize("무치악 환자 치료의 새로운 패러다임") }}</span>
              <p
                v-html="localize('복제덴처, 왁스림 트레이, 페이스보우 레코드 등 복잡한 사전 준비 없이,<br/>환자 방문 당일 디지털 데이터를 취득하고 인공지능 기반 얼굴<br/>패턴 분석을 통해 VD와 교합 평면을 설정,<br/>즉시 치료 계획까지 완료할 수 있습니다.')"
              />
            </div>
            <a class="main-thumb video">
              <video ref="fullMouth_videoRef" controls autoplay muted loop>
                <source src="https://playgroundmaintenance.blob.core.windows.net/webstaticassets/Video/R2_Full_Mouth_Solution/R2_Full_Mouth_Solution.mp4" type="video/mp4"/>
                Your browser does not support the video tag.
              </video>
            </a>
            <div class="program-items">
              <div class="item">
                <div class="item-top">
                  <a class="item-thumb video">
                    <video controls>
                      <source src="https://playgroundmaintenance.blob.core.windows.net/webstaticassets/Video/R2StudioQ/R2studioQ.mp4" type="video/mp4"/>
                      Your browser does not support the video tag.
                    </video>
                  </a> 
                  <div class="item-desc">
                    <span class="fs-xs">Digital Work Station</span>
                    <h3>R2studio Q™</h3>
                    <div v-html="localize('생성형 디지털 워크스테이션으로의 진화<br/>메가젠은 2019년 R2studio에서 2022년 R2studioQ에 이르기까지,<br/>단순한 CBCT를 넘어, 환자의 모든 데이터를 통합적으로 채득할 수 있는<br/>생성형 디지털 워크스테이션으로 발전시켜 왔습니다.<br/>R2studioQ는 환자의 Skeletal, Fcial, STL데이터를 간편하게 획득하고,<br/><strong>전악치료 계획을 위한 모든 준비를 10분 이내에 완료할 수 있도록 설계된<br/> 디지털 워크스테이션입니다.</strong>')" />
                  </div>
                </div>
                <div class="item-btns">
                  <div>
                    <p>Brochure download</p>
                    <a href="https://playgroundmaintenance.blob.core.windows.net/webstaticassets/R2STUDIO_Q_Broucher/R2-STUDIO-Q-(KR).pdf" class="btn btn-outline btn-manual" target="_blank" rel="noopener noreferrer"> <i class="icon-manual"></i>KOR </a>
                    <a href="https://playgroundmaintenance.blob.core.windows.net/webstaticassets/R2STUDIO_Q_Broucher/R2_STUDIO-Q-(EN).pdf" class="btn btn-outline btn-manual" target="_blank" rel="noopener noreferrer"> <i class="icon-manual"></i>ENG </a>
                  </div>
                  <div>
                    <p>Clinical casebook</p>
                    <a href="https://boot-static-assets.r2playground.com/download/docs/megagen_full_mouth_solution_clinical_casebook_kr.pdf" class="btn btn-outline btn-manual" target="_blank" rel="noopener noreferrer"> <i class="icon-manual"></i>KOR </a>
                  </div>
                </div>
              </div>
              <div class="item">
                <div class="item-top">
                  <a class="item-thumb video">
                    <video controls>
                      <source src="https://playgroundmaintenance.blob.core.windows.net/webstaticassets/Video/QVD/QVD.mp4" type="video/mp4"/>
                      Your browser does not support the video tag.
                    </video>
                  </a>
                  <div class="item-desc">
                    <h3>QVD</h3>
                    <div v-html="localize('AI 기반의 정밀한 수직고경 설정<br/>R2studioQ에 포함된 Q.V.D(R2studioQ Vertical Dimension) 소프트<vr/>웨어는 인공지능을 활용해 환자의 Skeletal 패턴을 분석하고,<br/>이상적인 수직고경(VD)을 자동으로 제안하며,<br/>이를 바탕으로 교합평명과치아 배열을 완성할 수 있는<br/>무치악 치료 계획에 특화된 소프트웨어입니다.')" />
                  </div>
                </div>
                <div class="item-btns">
                  <div class="item-caution">
                    *
                    {{
                      localize("Q.V.D 모듈은 R2GATE SA의 유료 기능으로, R2studioQ 구매 고객에게는 무료로 제공됩니다.")
                    }}
                  </div>
                </div>
              </div>
              <div class="item">
                <div class="item-top">
                  <a class="item-thumb video">
                    <video controls>
                      <source src="https://playgroundmaintenance.blob.core.windows.net/webstaticassets/Video/smile_creator_APP/Smile_creator.mp4" type="video/mp4"/>
                      Your browser does not support the video tag.
                    </video>
                  </a>
                  <div class="item-desc">
                    <h3>Ai Smile Creator</h3>
                    <div
                      v-html="
                        localize('밝아진 표정, 아름다운 미소는 강력한 치료 동기를 만듭니다.<br/>Ai Smile Creator는 R2studioQ에서 획득한 페이스 스캔을 바탕으로<br/>이상적인 스마일 시뮬레이션을 제공하며,<br/>시뮬레이션에서 결정된 치아 위치는 Q.V.D로 자동 연동되어<br/>치아 배열의 기준이 됩니다.')
                      "
                    /> 
                  </div>
                </div>     
                <div class="item-btns">
                  <div class="item-caution">
                    *
                    {{
                      localize("Ai smile creator app은 R2studioQ 구매 고객에게 무료로 제공됩니다.")
                    }}
                  </div>
                </div>
                <!-- <div class="item-btns" :class="{ active: state.smileCreator }">
                  <button
                    type="button"
                    class="btn-drop-down"
                    @click="state.smileCreator = !state.smileCreator"
                  ></button>
                  <div>
                    <h1>Coming Soon</h1>
                  </div>
                  <div>
                    <p>Brochure download</p>
                    <a href="" class="btn btn-outline btn-manual"> <i class="icon-manual"></i>KOR </a>
                    <a href="" class="btn btn-outline btn-manual"> <i class="icon-manual"></i>ENG </a>
                  </div>
                  <div>
                    <p>Manual</p>
                    <a href="" class="btn btn-outline btn-manual"> <i class="icon-manual"></i>ENG </a>
                  </div>
                  <div>
                    <p>Demo project download</p>
                    <a href="" class="btn btn-outline"> Demo<i class="icon icon-download"></i> </a>
                  </div>
                </div> -->
                <!-- <div class="precautions">
                  <p>PRECAUTIONS</p>
                  <div class="tb-head">Prerequisite</div>
                  <table>
                    <tbody>
                      <tr>
                        <td>
                          The minimum specification required to run the app smoothly are as belows.<br />
                          - Apple iPad Pro 11
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div class="tb-head">Notice</div>
                  <table>
                    <tbody>
                      <tr>
                        <td>
                          he app can collect images you've worked on.<br />
                          The information collected does not include sensitive information<br />
                          such as 'who you are', 'what is your name' or 'what is your ID'.<br />
                          The collected images are used to improve AI, collected, it isn't used for any other purpose.
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div class="tb-head">Caution</div>
                  <table>
                    <tbody>
                      <tr>
                        <td>
                          'MEGAGEN SMILE CREATOR' for Apple iPad might be blocked by Apple's safety policy. so when you
                          open it, if it doesn't work,
                          <div class="bx">
                            <p>1. Go to system settings</p>
                            <p>2. Select 'General'</p>
                            <p>3. Select 'Device Management</p>
                            <p>4. Select 'Megagen Implant Co.,Ltd'</p>
                            <p>5. Tap 'Trust "Megagen Implant Co.,Ltd"</p>
                            <p>6. Tab 'Trust' one more time</p>
                            <p>7. Tab 'SmileCreator' App</p>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div> -->
              </div>
            </div>
          </div>
        </div>
        <div :ref="sectionRefItems[2]" id="solution4"> 
          <div class="container">
            <div class="solution-title-wrap">
              <h2>
                <img src="@/assets/home/img/solution/r2solution-megaligner.png" alt="" />
              </h2>
              <span>{{ localize("임플란트·보철 치료를 위한 투명 교정 솔루션")}}</span>
              <p
                v-html="
                localize('치아 배열 이상이나 Malposition으로 인해<br/><strong>임플란트 또는 보철 치료에서 심미적인 결과를 얻기 어려웠던 경우,</strong><br/>Meg Aligner가 간편하고 효과적인 해결책이 되어드립니다.')
                "
              />
            </div>
            <div class="main-thumb">
              <a class="main-thumb video">
                <video controls >
                  <source src="https://playgroundmaintenance.blob.core.windows.net/webstaticassets/Video/R2_Ortho_Solution/R2_Ortho_Solution.mp4" type="video/mp4"/>
                  Your browser does not support the video tag.
                </video>
              </a>
            </div>
            <div class="program-items">
              <div class="item" >
                <div class="item-top">
                  <a class="item-thumb video">
                    <video controls poster="@/assets/home/img/solution/r2solution4-3.jpg">
                      <source src="https://playgroundmaintenance.blob.core.windows.net/webstaticassets/Video/Meg_Aligner/Meg_Aligner.mp4" type="video/mp4"/>
                      Your browser does not support the video tag.
                    </video>
                  </a>
                  <div class="item-desc">
                    <img src="@/assets/home/img/solution/r2solution-megaligner.png" alt="" class="w-50 mb-4" />
                    <!-- <h5>{{ localize('메가젠 임플란트에서 투명 교정을 ?!') }}</h5> -->
                    <div
                      v-html="
                      localize('<strong>임플란트와 보철 치료에도 교정이 필요할 수 있습니다.</strong><br/>치아의 Malposition 때문에 임플란트 치료 계획에 여러움을 겪은 경험이 있으신가요?<br/>보철 치료를 앞둔 화자가 이상 치열이나 Crowding을 가지고 있진 않으셨나요?<br/><strong>교정 전문 치과에서도 투명 교정이 필요할 수 있습니다.</strong><br/>사회 활동이 많은 성인 환자의 심미적 컴플렉스 해소를 위한 투명교정<br/>교정 치료 종료 후 경미한 Relapse나 Space Closing이 필요할 때<br/><strong>검증된 소재,빠른결과</strong><br/>Made in Germany의 3중 구조 시트는 높은 탄성과 지속력을 바탕으로<br/>더 빠르고 안정적인 교정 결과를 기대할 수 있습니다.')
                      "
                    />
                  </div>
                </div>
                <div class="item-btns">
                  <div>
                    <p>Brochure download</p>
                    <a href="https://playgroundmaintenance.blob.core.windows.net/webstaticassets/Meg_Aligner/Meg_Aligner-KOR.pdf" class="btn btn-outline btn-manual" target="_blank" rel="noopener noreferrer"> <i class="icon-manual"></i>KOR </a>
                    <a href="https://playgroundmaintenance.blob.core.windows.net/webstaticassets/Meg_Aligner/Meg_Aligner-EN.pdf" class="btn btn-outline btn-manual" target="_blank" rel="noopener noreferrer"> <i class="icon-manual"></i>ENG </a>
                  </div>
                  <div class="custom-contact">
                    <img src="@/assets/home/img/solution/r2solution-contact-icon.png" alt="" style="width: 150px;"/>
                    <div>
                      <p class="tel">053-222-2505</p>
                      <p class="kakao">megaligner</p>
                      <p class="email">megaligner@imegagen.com</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="item" id="solution-r2-ortho-lite">
                <div class="item-top">
                  <div class="item-thumb">
                    <a class="item-thumb video">
                    <video controls poster="@/assets/home/img/solution/r2solution4-2.jpg">
                      <source src="https://playgroundmaintenance.blob.core.windows.net/webstaticassets/Video/R2_OrthoLite/R2_OrthoLite.mp4" type="video/mp4"/>
                      Your browser does not support the video tag.
                    </video>
                  </a>
                  </div>
                  <div class="item-desc">
                    <h3>R2 Ortho Lite</h3>
                    <div
                        v-html="
                          localize('<strong>Meg Aligner Lite로 교정 계획을 한눈에!</strong><br/>Meg Aligner Lite는 교정 단계별 치아 이동 계획과 IPR 정보를 포함한<br/>세부 데이터를 직관적으로 제공합니다.<br/>또한, 필요 시 직접 수정할 수 있는 편리한 편집 기능도 함께 지원합니다.')  
                        "
                    />
                  </div>
                </div>
                <div class="item-btns">
                  <div>
                    <div class="count-wrap">
                      <p>Program Download</p>
                      <p class="count-num" data-type="ORTHO_LITE">Total : 0</p>
                    </div>
                    <div class="btns-wrap">
                      <button @click="onClickAppDownload('ORTHO_LITE', 'windows')" :disabled="isLoading" class="btn btn-maincolor" target="_blank" rel="noopener noreferrer">
                        Windows
                        <i class="icon icon-download-wh"></i>
                      </button>
                      <button @click="onClickAppDownload('ORTHO_LITE', 'macosx')" :disabled="isLoading" class="btn btn-maincolor" target="_blank" rel="noopener noreferrer">
                        MacOSX
                        <i class="icon icon-download-wh"></i>
                      </button>
                      <button @click="onClickAppDownload('ORTHO_LITE', 'ios')" :disabled="isLoading" class="btn btn-maincolor" target="_blank" rel="noopener noreferrer">
                        iOS
                        <i class="icon icon-download-wh"></i>
                      </button>
                      <button @click="onClickAppDownload('ORTHO_LITE', 'android')" :disabled="isLoading" class="btn btn-maincolor" target="_blank" rel="noopener noreferrer">
                        Android
                        <i class="icon icon-download-wh"></i>
                      </button>
                    </div>
                  </div>
                  <div>
                    <p>Manual</p> <!-- Player 페이지에서 바로가기 해시를 위한 미세조정 위치 -->
                    <div>
                      <a href="https://boot-static-assets.r2playground.com/download/docs/ortho_lite_manual_kr.pdf" class="btn btn-outline btn-manual" target="_blank" rel="noopener noreferrer"> <i class="icon-manual"></i>KOR </a>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
        <div :ref="sectionRefItems[3]" id="solution5">
          <div class="container">
            <div class="solution-title-wrap">
              <h2>R2 CAD/CAM</h2>
              <span>{{ localize("진료 플로어를 혁신하는 통합 CAD/CAM 솔루션") }}</span>
              <p
                v-html="
                  localize('Chair-side에서 손쉽게 활용할 수 있는 CAD 디자인부터,<br/>AI 기반 자동 디자인, 클라우드 연동을 통한 원격 제어 밀링 장치까지-<br/>임상에 필요한 모든 디자인과 제작 과정을<br/>하나의 디지털 워크 플로우를 제공합니다.')
                "
              />
            </div>
            <div class="main-thumb">
              <video controls>
                <source src="https://playgroundmaintenance.blob.core.windows.net/webstaticassets/Video/R2CAD/R2solution_R2cadcam.mp4" type="video/mp4"/>
                Your browser does not support the video tag.
              </video>
            </div>
            <div class="program-items">
              <div class="item">
                <div class="item-top">
                  <div class="item-thumb">
                    <video controls>
                      <source src="https://playgroundmaintenance.blob.core.windows.net/webstaticassets/Video/R2i3/R2solution_R2i3.mp4" type="video/mp4"/>
                      Your browser does not support the video tag.
                    </video>
                  </div>
                  <div class="item-desc">
                    <h3>R2i3/R2i5</h3>
                    <div
                      v-html="
                      localize('<strong>빠르고 직관적인 AI 구강 스캐너, R2i3/R2i5</strong><br/>매일의 진료에서 가장 필요한 기능들만 모았습니다.<br/>선명한 스캔 이미지는 물론, 실시간으로 구강 상태를 분석해<br/>치아 우식, 크랙 등 병변을 빠르게 감지하고 진달할 수 있습니다.<br/>단 몇번의 클릭만으로 환자 상담부터 치료 계획까지,<br/>쉽고 간편한 디지털 임상을 경험해보세요.')"
                    />
                  </div>
                </div>
                <div class="item-btns">
                  <div>
                    <p>Program Download</p>
                    <a v-bind:href="r2i3DownloadLink" target="_blank" class="btn btn-maincolor">{{ localize("R2iOS 다운로드") }} <i class="icon icon-download-wh"></i></a>
                  </div>
                  <div>
                    <p>Manual</p>
                    <a href="https://playgroundmaintenance.blob.core.windows.net/webstaticassets/R2i3/R2i3_KOR_rev.01.pdf" class="btn btn-outline btn-manual" target="_blank" rel="noopener noreferrer"> <i class="icon-manual"></i>KOR </a>
                    <a href="https://playgroundmaintenance.blob.core.windows.net/webstaticassets/R2i3/R2i3_EN_rev.01.pdf" class="btn btn-outline btn-manual" target="_blank" rel="noopener noreferrer"> <i class="icon-manual"></i>ENG </a>
                  </div>
                </div>
              </div>
              <div class="item">
                <div class="item-top">
                  <div class="item-thumb">
                    <video controls>
                      <source src="https://playgroundmaintenance.blob.core.windows.net/webstaticassets/Video/ChiTok/chi-tok.MP4" type="video/mp4"/>
                      Your browser does not support the video tag.
                    </video>
                  </div>
                  <div class="item-desc">
                    <h3>Chi-Tok</h3>
                    <div
                      v-html="
                        localize('<strong>빠르고 간편한 상담 메신저, Chi-Tok</strong><br/>진료실과 기공소를 실시간으로 연결하는 스마트한 소통 툴입니다.<br/>스캔 데이터를 즉시 공유하고, 환자 케이스를 실시간으로 논의해<br/>정확하고 신속한 치료 계획과 보철물 제작이 가능합니다.<br/>진료의 시작부터 끝까지, Chi-Tok 하나로 쉽고 빠르게 소통해 보세요.')
                      "
                    />
                  </div>
                </div>
                <div class="item-btns">
                  <div>
                    <p>Program Download</p>
                    <a v-bind:href="r2i3DownloadLink" target="_blank" class="btn btn-maincolor">{{ localize("Chi-Tok 다운로드") }} <i class="icon icon-download-wh"></i></a>
                  </div>
                  <div>
                    <p>Manual</p>
                    <a href="https://playgroundmaintenance.blob.core.windows.net/webstaticassets/CHITOK/CHITOK_KR_rev.01.pdf" class="btn btn-outline btn-manual" target="_blank" rel="noopener noreferrer"> <i class="icon-manual"></i>KOR </a>
                    <a href="https://playgroundmaintenance.blob.core.windows.net/webstaticassets/CHITOK/CHITOK_EN_rev.01.pdf" class="btn btn-outline btn-manual" target="_blank" rel="noopener noreferrer"> <i class="icon-manual"></i>ENG </a>
                  </div>
                </div>
              </div>                            
              <div class="item">
                <div class="item-top">
                  <div class="item-thumb">
                    <img src="@/assets/home/img/solution/r2solution5-1.jpg" alt="" />
                  </div>
                  <div class="item-desc">
                    <h3>R2 CAD</h3>
                    <div
                      v-html="
                        localize('<strong>가볍고 실용적인 Chair-side CAD</strong><br/>매일의 임상에서 자주 사용되는 핵심 기능만을 담은<br/>컴팩트한 Chair-side CAD입니다.<br/>Temporary Crown, Inlay, Onlay 등을<br/>간편하게 디자인할 수 있습니다.')
                      "
                    />
                  </div>
                </div>
                <div class="item-btns">
                  <div>
                    <p>Program Download</p>
                    <a v-bind:href="r2CadDownloadLink" target="_blank" class="btn btn-maincolor">{{ localize("R2CAD Download") }}<i class="icon icon-download-wh"></i></a>
                  </div>
                  <div>
                    <p>Manual</p>
                    <a href="https://playgroundmaintenance.blob.core.windows.net/webstaticassets/R2CAD/R2CAD_Full-Manual-(KOR).pdf" class="btn btn-outline btn-manual" target="_blank" rel="noopener noreferrer"> <i class="icon-manual"></i>KOR </a>
                    <a href="https://playgroundmaintenance.blob.core.windows.net/webstaticassets/R2CAD/R2CAD_Full-manual-(EN).pdf" class="btn btn-outline btn-manual" target="_blank" rel="noopener noreferrer"> <i class="icon-manual"></i>ENG </a>
                  </div>
                </div>
              </div>
              <div class="item">
                <div class="item-top">
                  <div class="item-thumb">
                    <video controls>
                      <source src="https://playgroundmaintenance.blob.core.windows.net/webstaticassets/Video/R2CAD/R2solution_R2cadair.mp4" type="video/mp4"/>
                      Your browser does not support the video tag.
                    </video>
                  </div>
                  <div class="item-desc">
                    <h3>R2 CAD AIR</h3>
                    <div
                      v-html="
                        localize('<strong>간단한 크라운 디자인, AI에게 맡겨보세요.</strong><br/>Pingpong을 통해 STL 파일을 간편하게 업로드하면,<br/>AI가 수분 내에 디자인을 완성해 드립니다.<br/>완성된 파일은 바로 다운로드하실 수 있어요.<br/>브릿지 디자인은 아직 살짝 어려운<br/>초보 AI 디자이너랍니다.')
                      "
                    />
                  </div>
                </div>
                <div class="item-btns">
                  <div>
                    <p>Program Download</p>
                    <a href="/home/support/inquiry-save" class="btn btn-maincolor justify-content-center" style="pointer-events: none;">{{ localize("준비 중")}}</a>
                    <!-- <a href="/home/support/inquiry-save" class="btn btn-maincolor">iOS<i class="icon icon-download-wh"></i></a>
                    <a href="/home/support/inquiry-save" class="btn btn-maincolor">Windows<i class="icon icon-download-wh"></i></a>
                    <a href="/home/support/inquiry-save" class="btn btn-maincolor">MacOSX<i class="icon icon-download-wh"></i></a> -->
                  </div>
                  <div>
                    <p>Manual</p>
                    <a href="https://playgroundmaintenance.blob.core.windows.net/webstaticassets/R2CAD/R2CAD_Full-Manual-(KOR).pdf" class="btn btn-outline btn-manual disabled" target="_blank" rel="noopener noreferrer"> <i class="icon-manual"></i>KOR </a>
                    <a href="https://playgroundmaintenance.blob.core.windows.net/webstaticassets/R2CAD/R2CAD_Full-manual-(EN).pdf" class="btn btn-outline btn-manual disabled" target="_blank" rel="noopener noreferrer"> <i class="icon-manual"></i>ENG </a>
                  </div>
                </div>
              </div>              
              <div class="item" id="solution-r2-pros-lite">
                <div class="item-top">
                  <div class="item-thumb">
                    <img src="@/assets/home/img/solution/r2solution5-2.jpg" alt="" />
                  </div>
                  <div class="item-desc">
                    <h3>R2 Pros Lite</h3>
                    <div
                      v-html="
                        localize('<strong>디자인 확인과 컨펌을 위한 전용 애플리케이션 – R2 Pros Lite</strong><br/>R2 Pros Lite는 STL, PLY, OBJ 파일을 확인하고,<br/><strong>필요한 부분에 코멘트나 메모를 자유롭게 추가할 수 있는</strong> CAD 전용 뷰어입니다.<br/>계정 로그인 시, 내가 주문한 디자인 파일이 자동으로 다운로드되며<br/>확인 및 컨펌 기능이 활성화됩니다.<br/>로그인 없이도 일반 3D 뷰어로 자유롭게 사용할 수 있습니다.')
                      "
                    />
                  </div>
                </div>
                <div class="item-btns">
                  <div>
                  <div class="count-wrap">
                      <p>Program Download</p>
                      <p class="count-num" data-type="PROS_LITE">Total : 0</p>
                    </div>
                    <div class="btns-wrap">
                      <button @click="onClickAppDownload('PROS_LITE', 'windows')" :disabled="isLoading" class="btn btn-maincolor" target="_blank" rel="noopener noreferrer">
                        Windows
                        <i class="icon icon-download-wh"></i>
                      </button>
                      <button @click="onClickAppDownload('PROS_LITE', 'macosx')" :disabled="isLoading" class="btn btn-maincolor" target="_blank" rel="noopener noreferrer">
                        MacOSX
                        <i class="icon icon-download-wh"></i>
                      </button>
                      <button @click="onClickAppDownload('PROS_LITE', 'ios')" :disabled="isLoading" class="btn btn-maincolor" target="_blank" rel="noopener noreferrer">
                        iOS
                        <i class="icon icon-download-wh"></i>
                      </button>
                      <button @click="onClickAppDownload('PROS_LITE', 'android')" :disabled="isLoading" class="btn btn-maincolor" target="_blank" rel="noopener noreferrer">
                        Android
                        <i class="icon icon-download-wh"></i>
                      </button>
                    </div>
                  </div>
                  <div>
                    <p>Manual</p>
                    <a href="https://boot-static-assets.r2playground.com/download/docs/pros_lite_manual_kr.pdf" class="btn btn-outline btn-manual" target="_blank" rel="noopener noreferrer"> <i class="icon-manual"></i>KOR </a>
                    <a href="https://boot-static-assets.r2playground.com/download/docs/pros_lite_manual_en.pdf" class="btn btn-outline btn-manual" target="_blank" rel="noopener noreferrer"> <i class="icon-manual"></i>ENG </a>
                  </div>
                </div>
              </div>
              <div class="item">
                <div class="item-top">
                  <div class="item-thumb">
                    <img src="@/assets/home/img/solution/r2solution5-3.jpg" alt="" />
                  </div>
                  <div class="item-desc">
                    <h3>CAD/CAM Library</h3>
                    <div
                      v-html="
                        localize('<strong>메가젠 유저를 위한 전용 CAD/CAM 라이브러리 제공</strong><br/>Scan Abutment, Ti-base, Premilled Abutment 등 다양한 보철 디자인이 가<br/>능한 정규 CAD 소프트웨어(3Shape, EXOCAD, Blender, Dental Wings 등)용<br/>라이브러리를 제공합니다.<br/>또한, 다양한 임상 응용을 위한 확장 라이브러리도 함께 지원합니다.<br/><strong>특별한 라이브러리가 필요하신 경우, cs@r2playground.com에 남겨주세요.</strong>')
                      "
                    />
                  </div>
                </div>
                <div class="item-btns">
                  <div>
                    <!-- <a href="https://r2gate.com/cad-cam?cate=3shape" class="btn btn-maincolor" target="_blank" rel="noopener noreferrer">{{ localize("전체 Library 받기") }}<i class="icon icon-download-wh"></i></a> -->
                    <a href="https://r2gate.com/cad-cam?cate=3shape" class="btn btn-maincolor" target="_blank" rel="noopener noreferrer">{{ localize("개별 Library 받기") }}<i class="icon icon-download-wh"></i></a>
                  </div>
                  <div>
                    <!-- <div
                      v-html="
                        localize('<strong>전체 Library 받기 :</strong> 메가젠 전체 정규 라이브러리를 ZIP 파일로 한번에 내려 <br/>받는기능 (3shape, EXOCAD, Dental wing)')
                      " 
                    /> -->
                    <div
                      v-html="
                        localize('<strong>개별 Library 받기 :</strong> R2GATE를 통해서 3shape, EXOCAD, Dental wing을 <br/>개별로 다운로드 받을 수 있습니다.')
                      "
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div :ref="sectionRefItems[4]" id="solution3">
          <div class="container">
            <div class="solution-title-wrap">
              <h2>FaceGIDE Solution</h2> 
              <span>
                <b>{{ localize("디지털 양악 수술 솔루션, FaceGIDE") }}</b>
              </span>
              <p
                v-html="
                  localize('FaceGIDE는 2016년부터 디지털 양악 수술을 선도해 온<br/>환자 맞춤형 양악 수술 솔루션입니다.<br/>Bone segmentation을 위한 Saw Guide와<br/>환자 골 형태에 정확히 맞는 맞춤형 Plate를 제공하여,<br/>정확하고 안전한 수술을 돕습니다.')
                "
              />
            </div> 
            <div class="main-thumb">
              <a class="main-thumb video">
                <video controls poster="@/assets/home/img/solution/r2solution3.jpg">
                  <source src="https://playgroundmaintenance.blob.core.windows.net/webstaticassets/Video/FaceGIDE_Solution/IDS_FG_FINAL190228_vol.2.mp4" type="video/mp4"/>
                  Your browser does not support the video tag.
                </video>
              </a>
            </div>
            <div class="program-items">
              <div class="item">
                <div class="item-top">
                  <div class="item-thumb">
                      <img src="@/assets/home/img/solution/r2solution-fg.png" alt="" />
                  </div>     
                  <div class="item-desc">
                    <h3>FaceGIDE™</h3>
                    <div
                      v-html="
                        localize('<strong>양악 수술을 위한 맞춤형 All-in-One 디지털 솔루션</strong><br/>FaceGIDE는 CBCT 데이터를 기반으로, 환자 개별에 최적화된 수술 계획과 Jaw<br/>Setup을 디지털로 진행합니다.<br/>수술 계획은 사용자의 확인을 거쳐 확정되며,<br/>확정된 계획에 따라 Bone Segmentation을 위한 Saw Guide와<br/>환자의 골 외형에 정확히 맞춤형 Plate를<br/>정밀하게 가공하여 병원으로 배송합니다.')
                      "
                    />
                    <p class="mt-2 text-muted" style="font-size: 14px; font-weight: normal;">
                      *
                      {{
                        localize("FaceGIDE setup module은 Beta version으로써 Try를 원하시는 분들에게만 별도로 제공되며 관리됩니다.")
                      }}
                    </p>
                  </div>
                </div>
                <div class="item-btns">
                  <div>
                    <p>Please contact below email for beta trial program</p>
                    <p class="btn btn-subcolor custom-cursor"><i class="icon-mail"></i> r2.face@imegagen.com</p>
                  </div>
                  <div>
                    <p>Manual</p>
                    <a href="https://playgroundmaintenance.blob.core.windows.net/webstaticassets/FaceGIDE/FACEGIDE Order GuideBook.pdf" class="btn btn-outline btn-manual" target="_blank" rel="noopener noreferrer"> <i class="icon-manual"></i>Order preparation</a>
                    <a href="https://playgroundmaintenance.blob.core.windows.net/webstaticassets/FaceGIDE_Setup_Module/FaceGIDE_Setup-module-And-FG-Lite-user-manual-v1-1.pdf" class="btn btn-outline btn-manual" target="_blank" rel="noopener noreferrer"> <i class="icon-manual"></i>ENG</a>
                    <a href="https://www.youtube.com/watch?v=4pvXaKsORpg" class="btn btn-outline btn-manual" target="_blank" rel="noopener noreferrer"> <img class="custom-icon-youtube" src="@/assets/playground/img/youtube.png" alt="" /> YouTube</a>
                  </div>
                </div>
              </div>
              <div class="item" id="solution-facegide-lite">
                <div class="item-top">
                  <a class="item-thumb video">
                    <video controls poster="@/assets/home/img/solution/r2solution3-2.jpg">
                      <source src="https://playgroundmaintenance.blob.core.windows.net/webstaticassets/Video/FaceGIDE_Lite/FaceGIDE_Lite.mp4" type="video/mp4"/>
                      Your browser does not support the video tag.
                    </video>
                  </a>
                  <div class="item-desc">
                    <h3>FaceGIDE Lite</h3>
                    <div
                      v-html="
                        localize('<strong>FaceGIDE Lite는 양악 수술 계획의 확인과 수정을 위한 전용 애플리케이션입니다.<br/>Bone Segment의 위치 이동, 수술 전·후 비교 시뮬레이션, Saw Guide 및 맞춤형 Plate<br/>디자인까지 확인할 수 있어, 수술 전 완벽한 점검이 가능하며,<br/>필요 시 직접 수정도 할 수 있습니다.<br/>FaceGIDE Lite는 FaceGIDE 센터에서 제작된 프로젝트 파일을 기반으로 실행됩니다.</strong><br/>자세한 사항은 FaceGIDE 센터로 문의해 주세요.')
                      "
                    />
                  </div>
                </div>
                <div class="item-btns">
                  <div>
                    <div class="count-wrap">
                      <p>Program Download</p>
                      <p class="count-num" data-type="FACEGIDE_LITE">Total : 0</p>
                    </div>
                    <div class="btns-wrap">
                      <button @click="onClickAppDownload('FACEGIDE_LITE', 'windows')" :disabled="isLoading" class="btn btn-maincolor" target="_blank" rel="noopener noreferrer">
                        Windows
                        <i class="icon icon-download-wh"></i>
                      </button>
                      <button @click="onClickAppDownload('FACEGIDE_LITE', 'macosx')" :disabled="isLoading" class="btn btn-maincolor" target="_blank" rel="noopener noreferrer">
                        MacOSX
                        <i class="icon icon-download-wh"></i>
                      </button>
                      <button @click="onClickAppDownload('FACEGIDE_LITE', 'ios')" :disabled="isLoading" class="btn btn-maincolor" target="_blank" rel="noopener noreferrer">
                        iOS
                        <i class="icon icon-download-wh"></i>
                      </button>
                      <button @click="onClickAppDownload('FACEGIDE_LITE', 'android')" :disabled="isLoading" class="btn btn-maincolor" target="_blank" rel="noopener noreferrer">
                        Android
                        <i class="icon icon-download-wh"></i>
                      </button>
                    </div>
                  </div>
                  <div>
                    <p>Manual</p>
                    <div>
                      <a href="https://boot-static-assets.r2playground.com/download/docs/facegide_lite_manual_kr.pdf" class="btn btn-outline btn-manual" target="_blank" rel="noopener noreferrer"> <i class="icon-manual"></i>KOR </a>
                      <a href="https://boot-static-assets.r2playground.com/download/docs/facegide_lite_manual_en.pdf" class="btn btn-outline btn-manual" target="_blank" rel="noopener noreferrer"> <i class="icon-manual"></i>ENG </a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="item">
                <div class="item-top">
                  <a class="item-thumb video">
                    <video controls poster="@/assets/home/img/solution/r2solution3-1.jpg">
                      <source src="https://playgroundmaintenance.blob.core.windows.net/webstaticassets/Video/FaceGIDE_Setup_module/FaceGIDE_Setup_module.mp4" type="video/mp4"/>
                      Your browser does not support the video tag.
                    </video>
                   </a>  
                  <div class="item-desc">
                    <h3>FaceGIDE setup module</h3>
                    <div
                      v-html="
                        localize('<strong>전문가를 위한 디지털 양악 수술 플래닝</strong><br/>FaceGIDE Setup 모듈은 CBCT와 스캔 파일을 활용해<br/>전문의가 직접 진단, Jaw Segmentation, Setup까지 수행할 수 있는<br/>양악 수술 전용 플래닝 소프트웨어입니다.<br/>해당 모듈은 R2GATE SA의 유료 기능이며,<br/>선별된 사용자에게 제공됩니다.')
                      "
                    />
                  </div>
                </div>
                <div class="item-btns">
                  <div>
                    <p>Please contact below email for beta trial</p>
                    <p class="btn btn-subcolor custom-cursor"><i class="icon-mail"></i> r2.face@imegagen.com</p>
                  </div>
                  <div>
                    <p>Manual</p>
                    <a href="https://playgroundmaintenance.blob.core.windows.net/webstaticassets/FaceGIDE_Setup_Module/FaceGIDE_Setup-module-And-FG-Lite-user-manual-v1-1.pdf" class="btn btn-outline btn-manual" target="_blank" rel="noopener noreferrer"> <i class="icon-manual"></i>ENG </a>
                    <a href="https://www.youtube.com/watch?v=4pvXaKsORpg" class="btn btn-outline btn-manual" target="_blank" rel="noopener noreferrer"> <img class="custom-icon-youtube" src="@/assets/playground/img/youtube.png" alt="" /> YouTube</a>
                  </div>
                </div>
                <!-- <div class="item-caution">
                  *
                  {{
                    localize("FaceGIDE setup module은 Beta version으로써 Try를 원하시는 분들에게만 별도로 제공되며 관리됩니다.")
                  }}
                </div> -->
              </div>
            </div>
          </div>
        </div>
        <div :ref="sectionRefItems[5]" id="solution6">
          <div class="container">
            <div class="solution-title-wrap">
              <h2>Facial<br/>Reconstruction</h2>
              <span>
                <b>{{ localize("FaceGIDE-F.R") }}</b>
              </span>
              <p
                v-html="
                  localize('<strong>FaceGIDE에서 확장된 Facial Reconstruction 솔루션</strong><br/>F.R(Facial Reconstruction) 솔루션은 외상이나 질병으로 소실된<br/>안면 골격 또는 연조직을 , 인체 친화적인 소재와 첨단 가공 기술을 활용해 수복하는<br/>환자 맞춤형 디지털 재건 솔루션입니다.')
                "
              />              
            </div>
            <div class="program-items">
              <div class="item">
                <img src="@/assets/home/img/solution/r2solution-fg-fr.png" alt="" class="mb-5"/>
                <div class="item-btns">
                  <div>
                    <p>Please contact below email for beta trial</p>
                    <p class="btn btn-subcolor custom-cursor" style="color: white"><i class="icon-mail"></i> r2.face@imegagen.com</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="outro">
          <div class="container">
            <h3>R2 Playground APP Program</h3>
            <p>{{ localize("R2 Playground는 모든 R2 solution을 통합 관리하는 프로그램입니다.") }}</p>
            <ul class="list-dot">
              <li>{{ localize('한번 설치하면 원하는 R2 solution 설치 가능') }}</li>
              <li>{{ localize('실시간 업데이트 및 중요 알림 수신 가능') }}</li>
              <li>{{ localize('온라인 주문으로 간편하게 디자인 및 보철물 주문 가능') }}</li>
              <li>{{ localize('주문자는 의뢰한 주문에 대해 디자인 컨펌까지 가능') }}</li>
            </ul>
            <!-- <a v-bind:href="downloadLink" target="_blank" class="btn btn-outline">
              {{ localize("Playground 다운로드") }}<i class="icon icon-download-wh"></i>
            </a> -->
          </div>
        </div>
        <!-- //container -->
      </main>
      <!-- footer -->
      <home-footer />
      <!-- //footer -->
    </div>
  </div>
</template>

<style scoped>
/* YouTube 버튼 스타일링*/
.custom-icon-youtube {
  width: 100%;
  height: 24px;
  margin-right: 5px;
}

/* contact 클래스 속성에서 flex-direction 속성을 추가한 사용자 정의 클래스 */
.custom-contact { 
  margin-top: 1.11rem;
  display: flex;
  justify-content: center; 
  align-items: center;
  gap: 60px;
  color: var(--color-dark);font-weight: 500;
}

/* contact 하위 클래스 재정의 */
.custom-contact p {display: flex; align-items: center;}
.custom-contact p::before {content: ''; display: inline-block;width: 18px;height: 18px; margin-right: 10px;}
.custom-contact .tel::before {background: url(../../../src/assets/home/img/icon-contact-email.svg);}
.custom-contact .email::before {background: url(../../../src/assets/home/img/icon-contact-tel.svg);}
.custom-contact .kakao::before {background: url(../../../src/assets/home/img/icon-contact-kakao.svg);}
.custom-contact p:last-child::after {content: none;}

/* 블루 계열 버튼 스타일링 */
.custom-btn-subcolor {background-color: rgba(88, 75, 231, 0.1); color: var(--color-solution3);}

/* 마우스 커서 기본 값 설정 */
.container .item-btns .custom-cursor{ cursor: default; }

/* .item-thumb 요소 레이아웃 설정 및 비디오 스타일링 */
.solution .item-thumb {display: block; max-width: 667px;  aspect-ratio: 960/540;border-radius: 20px;overflow: hidden;}
.solution .item-thumb video {width: 100%; height: 100%; object-fit: cover}
.solution .video {position: static;}
.solution .item-thumb img {
  height: 100%;
}

/* 비디오 재생 버튼 제거  */
.solution .video::after {content: ''; position: absolute; background: none;}

.item-top {
  padding: 50px 0;
}
.count-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
}
.count-num {
  color: #5F5F5F;
}
/* 
.disabled {
  pointer-events: none;
  opacity: 1; 
  background-color: #f0eaea; 
  color: #7a7a7a; 
  cursor: not-allowed; 
} */
</style>
